"use client";
import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import ImageGallery from "react-image-grid-gallery";
import "./Autografika.css";
import Navbar from "../Navbar/Navbar";
import LijeviMeni from "../Pocetna/LijeviMeni";
import Footer from "../Pocetna/Footer/Footer";

import "./stirodur.css";

const importAll = (r) => r.keys().map(r);
const stirodurNatpisiImages = importAll(
  require.context("../../assets/zidnaGrafika", false, /\.(webp)$/i)
);

const ZidnaGrafika = () => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [buttonText, setButtonText] = useState("Pročitaj više");

  useEffect(() => {
    const fakeApiCall = setTimeout(() => {
      setIsContentLoaded(true);
    }, 1000);

    return () => clearTimeout(fakeApiCall);
  }, []);

  const imagesArray = stirodurNatpisiImages.map((image, index) => ({
    alt: `Image${index + 1}'s alt text`,
    src: image,
  }));

  const [isParagraphVisible, setIsParagraphVisible] = useState(false);

  const handleButtonClick = () => {
    setIsParagraphVisible(!isParagraphVisible);
    setButtonText(
      isParagraphVisible ? "Pročitaj više" : "Zatvori dodatni tekst"
    );
  };

  return (
    <div>
      {!isContentLoaded ? (
        <Loader />
      ) : (
        <>
          <Navbar />
          <div className="autografika-main">
            <div className="container">
              <div className="row reverse" id="usluge-navi">
                {/* Left column for */}
                <LijeviMeni />
                {/* Right column for */}
                <div className="col-md-8 bg">
                  <h1>Zidna Grafika</h1>{" "}
                  <div className="autografika-opis">
                    <p>
                      Iskoristite prednost štampe na velikom formatu za zidnu
                      grafiku.
                    </p>
                    <div className="vise-button">
                      <button
                        type="button"
                        className="btn btn-dark"
                        onClick={handleButtonClick}
                      >
                        {buttonText}
                      </button>
                    </div>

                    {isParagraphVisible && (
                      <>
                        <p>
                          Iskoristite prednost štampe na velikom formatu za
                          zidnu grafiku, koja Vam omogućuje da skrenete pažnju
                          kupaca i mušterija na Vašu firmu ili proizvode. Zidna
                          grafika trenutno pretvara Vašu kancelariju ili radnju
                          u primamljiviji objekat za potencijalne klijente ili
                          kupce i onima koji su Vas veæ posjetili razlog da doðu
                          ponovo.
                        </p>
                      </>
                    )}
                  </div>
                  <div className="stirodur-grid">
                    <ImageGallery
                      imgArray={imagesArray}
                      columnWidth={230}
                      gapSize={4}
                    />
                  </div>
                  <div className="stirodur-grid-mobile">
                    <ImageGallery
                      imgArray={imagesArray}
                      columnWidth={230}
                      gapSize={4}
                    />
                  </div>
                  <div className="display-text-mobile">
                    <p>
                      Iskoristite prednost štampe na velikom formatu za zidnu
                      grafiku, koja Vam omogućuje da skrenete pažnju kupaca i
                      mušterija na Vašu firmu ili proizvode. Zidna grafika
                      trenutno pretvara Vašu kancelariju ili radnju u
                      primamljiviji objekat za potencijalne klijente ili kupce i
                      onima koji su Vas veæ posjetili razlog da doðu ponovo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <Footer />
          </div>
        </>
      )}
    </div>
  );
};

export default ZidnaGrafika;
